import React, { useState, useEffect } from 'react';
import { MdOutlineLibraryAdd } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";
import { FaFolderOpen } from "react-icons/fa";
import Videos from './videos';
import CreateProductModal from './Modals/create_product_modal';
import axios from 'axios';
import EditProductModal from './Modals/update_product_modal';
import { MdDeleteForever } from "react-icons/md";
import Swal from 'sweetalert2';
import { AxiosInstance } from '../../../common/Loader/axios.config';


export default function Products({ setOpenProject, setSelectedProject, project }: { setOpenProject: (open: boolean) => void, setSelectedProject: (project: any) => void, project: any }) {
    const [openVideo, setOpenVideo] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [openProductModal, setOpenProductModal] = useState(false);
    const [openEditProductModal, setOpenEditProductModal] = useState(false);
    const [products, setProducts] = useState([]);

    // const AxiosInstance = axios.create({
    //     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
    // });

    const fetchProducts = async (limit = 10, item = "") => {
        let skip = 0;
        let allProducts = [];
        let hasMore = true;

        console.log("Passed Provider", project);

        while (hasMore) {
            try {
                const response = await AxiosInstance.get('/products', {
                    params: {
                        skip,
                        limit,
                        item,
                    },
                });

                const products = response.data.message;

                console.log("Products Response", products);

                // Filter projects based on the provider
                const filteredProducts = products.filter(product => product.project === project);

                allProducts = [...allProducts, ...filteredProducts];

                hasMore = products.length === limit;
                skip += limit;
            } catch (error) {
                console.error('Error fetching projects:', error);
                hasMore = false;
            }
        }

        const sortedProducts = allProducts.sort((a, b) => {
            return (
                new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
            );
        });
        setProducts(sortedProducts);
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const handleDeleteProduct = async (ProductID) => {
        try {
            const response = await AxiosInstance.delete(`/${ProductID}/product`);
            console.log("Delete Product Response", response);
            if (response.status == 200) {
                fetchProducts();
                Swal.fire({
                    icon: 'success',
                    title: 'Product deleted successfully!',
                    text: 'The product has been deleted successfully.',
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete provider',
                text: 'An error occurred while deleting the provider.',
            });
        }
    };

    return (
        <div className="w-full flex flex-col items-start justify-between">
            {openVideo ? ( <Videos videos={selectedProduct?.content} setOpenVideo={setOpenVideo} setSelectedProduct={setSelectedProduct} product={selectedProduct._id} /> ) : (
                <div className="w-full">
                    <div className="w-full flex items-center justify-between">
                        <div className='flex items-center text-lg font-bold text-white cursor-pointer hover:scale-105'
                            onClick={() => {
                                setOpenProject(false);
                                setSelectedProject(null);
                            }}
                        >
                            <IoIosArrowBack />
                            <p className="text-sm">Back</p>
                        </div>
                        <button className="flex items-center gap-x-1 rounded-lg bg-primary px-3 py-2 text-white duration-200 hover:scale-105"
                            onClick={() => setOpenProductModal(true)}
                        >
                            <MdOutlineLibraryAdd size={20} />
                            <p className="font-bold text-lg">New</p>
                        </button>
                    </div>
                    <div className='w-full flex items-center justify-between'>
                        <p className="text-lg font-bold text-white">Products</p>
                        <div></div>
                    </div>
                    <div className="grid grid-cols-3 gap-4 my-4">
                        {products.map((product) => (
                            <div key={product.name} className="bg-white text-black rounded-lg shadow-lg p-4 cursor-pointer">
                                <img src={product.thumb_nail} alt={product.title} className="w-full h-40 object-cover mb-4" />
                                <h3 className="text-lg font-semibold mb-2">{product.title}</h3>
                                <p className="text-gray-600 mb-2">{product.category}</p>
                                <p className="text-gray-600 mb-2">Price: MWK {product.price}</p>
                                <div className="flex items-center gap-x-2">
                                    <button
                                        className="rounded-md bg-primary px-3 py-1 text-white"
                                        onClick={() => {
                                            setSelectedProduct(product);
                                            setOpenEditProductModal(true);
                                        }}
                                    >
                                        Edit
                                    </button>

                                    <button
                                        className="flex items-center gap-x-1 rounded-md bg-primary px-3 py-1 text-white"
                                        onClick={() => {
                                            setSelectedProduct(product);
                                            setOpenVideo(true);
                                        }}
                                    >
                                        <FaFolderOpen size={18} />
                                        Open
                                    </button>

                                    <button className="rounded-md bg-brand-red p-2 text-white hover:scale-105 duration-200"
                                        onClick={() => {
                                            handleDeleteProduct(product._id);
                                        }}
                                    >
                                        <MdDeleteForever size={18} />
                                    </button>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {openProductModal && <CreateProductModal isOpen={openProductModal} onClose={() => setOpenProductModal(false)} project={project} fetchProducts={fetchProducts} />}
            {openEditProductModal && <EditProductModal isOpen={openEditProductModal} onClose={() => setOpenEditProductModal(false)} selectedProduct={selectedProduct} fetchProducts={fetchProducts} />}
        </div>
    )
}